import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findBindEngineer = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/engineer?` + params,
        method: 'GET'
    })
}
export const findUserList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user/findUserList?` + params,
        method: 'GET'
    })
}
export const getUser = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/get_user?` + params,
        method: 'GET'
    })
}
export const addBindEngineer = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/engineer`,
        method: 'POST',
        data: params
    })
}

export const delBindEngineer = (ids) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/engineer/${ids}`,
        method: 'DELETE',
    })
}

export const engineerBatchUpgrade = (params) => { //成功绑定关系的工程师，单个升级或批量升级
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/engineer/batchUpgrade?` + params,
        method: 'POST',
    })
}